'use strict';

/**
 * Animated Win / Shop header switcher.
 * Slides the white pill to the tapped side and marks it selected (black text).
 * The actual site switch for "Shop" is handled by sessionRedirect.js
 * (.js-handle-session-sharing), so this only drives the visual toggle.
 */
module.exports = function () {
    $(document).on('click', '.win-shop-switcher__option', function () {
        var $option = $(this);
        var $switcher = $option.closest('.win-shop-switcher');
        var target = $option.data('target') === 'shop' ? 'shop' : 'win';

        $switcher.removeClass('is-win is-shop').addClass('is-' + target);
        $switcher.find('.win-shop-switcher__option').attr('aria-selected', 'false');
        $option.attr('aria-selected', 'true');
    });
};
